import { render, staticRenderFns } from "./RequirementPurchase.vue?vue&type=template&id=6ba5dd5f"
import script from "./RequirementPurchase.vue?vue&type=script&lang=js"
export * from "./RequirementPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports